<template>
    <div class="box-container">
        <div id="home-section-one" class="container-size-fixer">
            <div class="row">
                <div class="section-one-main-child col-lg-6">
                    <img src="../assets/appIcons/Pics/canadaMap.png" alt="canadaMap">
                    <div id="text-content">
                        <div id="title">
                            گروه مهاجرتی
                            <span style="color: rgb(204, 23, 29)">کانادا از ایران</span>
                        </div>
                        <div class="description" v-if="explain">
                            {{explain}}
                        </div>
                        <div class="description" v-if="homeLoadingMood">
                            <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
                        </div>
                        <a class="btn-hover" v-on:click="$router.push('/user-signup')">
                            فرم ارزشیابی رایگان
                        </a>
                    </div>
                </div>
                <div class="section-one-main-child  col-lg-6">
                    <div id="img-content"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "HomeSectionOne",
        props:['explain','homeLoadingMood']
    }
</script>
<style scoped lang="scss">
    .box-container{
        overflow: hidden;
        margin-bottom: 10px;
    }
    #text-content{
        width: 100%;
        height: 500px;
        z-index: 10;
        position: relative;
        padding: 15px!important;
    }
    #title{
        width: 95%;
        height: 57px;
        font-family: IRANSans;
        font-size: 26px;
        /*font-size: min(max(36px, 4vw), 26px);*/

        /*font-size: min(4vw, 36px);*/
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
        margin-top: 160px;
        float: right;
    }
    .description{
        width: 95%;
        height: 77px;
        margin-top: 50px;
        font-family: 'IRANSans';
        font-size: 14px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
        float: right;
    }
    a{
        width: 369px;
        height: 54px;
        padding: 15px 108px;
        border-radius: 10px;
        background-color: #162336;
        float: right;
        color: white!important;
        margin-top: 30px;
    }


    #img-content{
        width: 495px;
        height: 500px;
        margin: 35px auto;
        background-image: url("../assets/appIcons/Pics/Home.png");
        background-size: cover;
        background-repeat: no-repeat;
    }
    #home-section-one{

    }
    .section-one-main-child{
        height: 567px;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .section-one-main-child>img{
        z-index: 1;
        position: absolute;
       left: 0;
        bottom: 0;
        top: 0;
        right: 0;
        height: 500px;
    }
    .section-one-main-child:nth-child(2){

    }
    #home-section-one{
        margin: auto;
        overflow: hidden;
        background-color: white;
    }
    @media (max-width: 1300px) {
        #text-content{
          margin-right: 15px;

        }
        #home-section-one{
            margin-top: -10px;
            padding: 0;
        }
        a{
            width: 80%;
            padding: 10px 0;
        }
        #img-content{
            width: 95%;
        }
    }
    @media (max-width: 992px) {
        .section-one-main-child:nth-child(2){
            display: none;
        }
    }
</style>